import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/sti-reverse-scan/icon-sti-dest.svg'
import _imports_1 from '@/app/ui/assets/svg/sti-reverse-scan/icon-sti.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "flex flex-col justify-center items-center gap-2",
  style: {"width":"fit-content"}
}
const _hoisted_3 = { class: "flex flex-row justify-center items-center" }
const _hoisted_4 = { class: "flex flex-row gap-4 items-center" }
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  alt: "icon-sti-sti-dest"
}
const _hoisted_6 = {
  key: 1,
  src: _imports_1,
  alt: "icon-sti"
}
const _hoisted_7 = {
  key: 2,
  class: "flex flex-col justify-center items-center gap-2"
}
const _hoisted_8 = { class: "px-4 py-2 rounded-full bg-green-lp-100 text-white text-2xl font-bold" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "text-red-lp-500 text-xl font-semibold" }, " Kiriman Penting ", -1)
const _hoisted_10 = {
  key: 0,
  class: "text-red-lp-500 text-xl font-semibold"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  class: "flex flex-col justify-center items-center gap-2",
  style: {"width":"fit-content"}
}
const _hoisted_13 = { class: "flex flex-row justify-center items-center" }
const _hoisted_14 = { class: "flex flex-row gap-4 items-center" }
const _hoisted_15 = {
  key: 0,
  src: _imports_0,
  alt: "icon-sti-sti-dest"
}
const _hoisted_16 = {
  key: 1,
  src: _imports_1,
  alt: "icon-sti"
}
const _hoisted_17 = {
  key: 2,
  class: "flex flex-col justify-center items-center gap-2"
}
const _hoisted_18 = { class: "px-4 py-2 rounded-full bg-green-lp-100 text-white text-2xl font-bold" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "text-red-lp-500 text-xl font-semibold" }, " Batas POD Terlewati ", -1)
const _hoisted_20 = {
  key: 0,
  class: "text-red-lp-500 text-xl font-semibold"
}
const _hoisted_21 = { key: 2 }
const _hoisted_22 = {
  class: "flex flex-col justify-center items-center gap-2",
  style: {"width":"fit-content"}
}
const _hoisted_23 = { class: "flex flex-row justify-center items-center" }
const _hoisted_24 = { class: "flex flex-row gap-4 items-center" }
const _hoisted_25 = {
  key: 0,
  src: _imports_0,
  alt: "icon-sti-sti-dest"
}
const _hoisted_26 = {
  key: 1,
  src: _imports_1,
  alt: "icon-sti"
}
const _hoisted_27 = {
  key: 2,
  class: "flex flex-col justify-center items-center gap-2"
}
const _hoisted_28 = { class: "px-4 py-2 rounded-full bg-green-lp-100 text-white text-2xl font-bold" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "text-red-lp-500 text-xl font-semibold" }, " Batas POD Hari Ini ", -1)
const _hoisted_30 = {
  key: 0,
  class: "text-red-lp-500 text-xl font-semibold"
}
const _hoisted_31 = { key: 3 }
const _hoisted_32 = {
  class: "flex flex-col justify-center items-center gap-2",
  style: {"width":"fit-content"}
}
const _hoisted_33 = { class: "flex flex-row justify-center items-center" }
const _hoisted_34 = { class: "flex flex-row gap-4 items-center" }
const _hoisted_35 = {
  key: 0,
  src: _imports_0,
  alt: "icon-sti-sti-dest"
}
const _hoisted_36 = {
  key: 1,
  src: _imports_1,
  alt: "icon-sti"
}
const _hoisted_37 = {
  key: 2,
  class: "flex flex-col justify-center items-center gap-2"
}
const _hoisted_38 = { class: "px-4 py-2 rounded-full bg-green-lp-100 text-white text-2xl font-bold" }
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "text-red-lp-500 text-xl font-semibold" }, " Batas RTS Terlewati ", -1)
const _hoisted_40 = {
  key: 0,
  class: "text-red-lp-500 text-xl font-semibold"
}
const _hoisted_41 = { key: 4 }
const _hoisted_42 = {
  class: "flex flex-col justify-center items-center gap-2",
  style: {"width":"fit-content"}
}
const _hoisted_43 = { class: "flex flex-row justify-center items-center" }
const _hoisted_44 = { class: "flex flex-row gap-4 items-center" }
const _hoisted_45 = {
  key: 0,
  src: _imports_0,
  alt: "icon-sti-sti-dest"
}
const _hoisted_46 = {
  key: 1,
  src: _imports_1,
  alt: "icon-sti"
}
const _hoisted_47 = {
  key: 2,
  class: "flex flex-col justify-center items-center gap-2"
}
const _hoisted_48 = { class: "px-4 py-2 rounded-full bg-green-lp-100 text-white text-2xl font-bold" }
const _hoisted_49 = /*#__PURE__*/_createVNode("div", { class: "text-red-lp-500 text-xl font-semibold" }, " Batas RTS Hari ini ", -1)
const _hoisted_50 = {
  key: 0,
  class: "text-red-lp-500 text-xl font-semibold"
}
const _hoisted_51 = { key: 5 }
const _hoisted_52 = {
  class: "flex flex-col justify-center items-center gap-2",
  style: {"width":"fit-content"}
}
const _hoisted_53 = { class: "flex flex-row justify-center items-center" }
const _hoisted_54 = { class: "flex flex-row gap-4 items-center" }
const _hoisted_55 = {
  key: 0,
  src: _imports_0,
  alt: "icon-sti-sti-dest"
}
const _hoisted_56 = {
  key: 1,
  src: _imports_1,
  alt: "icon-sti",
  width: "150",
  height: "110"
}
const _hoisted_57 = {
  key: 2,
  class: "flex flex-col justify-center items-center gap-2"
}
const _hoisted_58 = { class: "px-4 py-2 rounded-full bg-green-lp-100 text-white text-2xl font-bold" }
const _hoisted_59 = /*#__PURE__*/_createVNode("div", { class: "text-red-lp-500 text-xl font-semibold" }, " Batas RTS Besok ", -1)
const _hoisted_60 = {
  key: 0,
  class: "text-red-lp-500 text-xl font-semibold"
}
const _hoisted_61 = { key: 6 }
const _hoisted_62 = {
  class: "flex flex-col gap-2 justify-center",
  style: {"width":"fit-content"}
}
const _hoisted_63 = { class: "flex flex-row items-center justify-center" }
const _hoisted_64 = { class: "flex flex-row items-center gap-4" }
const _hoisted_65 = {
  key: 0,
  src: _imports_0,
  alt: "sti-sti-dest-icon"
}
const _hoisted_66 = {
  key: 1,
  src: _imports_1,
  alt: "sti-sti"
}
const _hoisted_67 = {
  key: 2,
  class: "px-4 py-2 rounded-full bg-green-lp-100 text-white text-2xl font-bold"
}
const _hoisted_68 = { key: 7 }
const _hoisted_69 = {
  class: "flex flex-col justify-center items-center gap-2",
  style: {"width":"fit-content"}
}
const _hoisted_70 = { class: "flex flex-row justify-center items-center" }
const _hoisted_71 = { class: "flex flex-row gap-4 items-center" }
const _hoisted_72 = {
  key: 0,
  src: _imports_0,
  alt: "icon-sti-sti-dest"
}
const _hoisted_73 = {
  key: 1,
  src: _imports_1,
  alt: "icon-sti"
}
const _hoisted_74 = {
  key: 2,
  class: "flex flex-col justify-center items-center gap-2"
}
const _hoisted_75 = { class: "px-4 py-2 rounded-full bg-green-lp-100 text-white text-2xl font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.flag.toLowerCase().includes('kiriman penting'))
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("img", {
                src: _ctx.woodpackingAsset,
                alt: "icon-woodpacking"
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_4, [
              (_ctx.isStiDest)
                ? (_openBlock(), _createBlock("img", _hoisted_5))
                : (_openBlock(), _createBlock("img", _hoisted_6)),
              (_ctx.regionName)
                ? (_openBlock(), _createBlock("div", _hoisted_7, [
                    _createVNode("div", _hoisted_8, _toDisplayString(_ctx.regionName), 1),
                    _hoisted_9
                  ]))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.regionName)
              ? (_openBlock(), _createBlock("div", _hoisted_10, " Kiriman Penting "))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.flag.toLowerCase().includes('lewat batas sla'))
      ? (_openBlock(), _createBlock("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _createVNode("img", {
                src: _ctx.woodpackingAsset,
                alt: "icon-woddpacking"
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_14, [
              (_ctx.isStiDest)
                ? (_openBlock(), _createBlock("img", _hoisted_15))
                : (_openBlock(), _createBlock("img", _hoisted_16)),
              (_ctx.regionName)
                ? (_openBlock(), _createBlock("div", _hoisted_17, [
                    _createVNode("div", _hoisted_18, _toDisplayString(_ctx.regionName), 1),
                    _hoisted_19
                  ]))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.regionName)
              ? (_openBlock(), _createBlock("div", _hoisted_20, " Batas POD Terlewati "))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (
      _ctx.flag.toLowerCase().includes('sla hari ini') ||
        _ctx.flag.toLowerCase().includes('delivery ulang')
    )
      ? (_openBlock(), _createBlock("div", _hoisted_21, [
          _createVNode("div", _hoisted_22, [
            _createVNode("div", _hoisted_23, [
              _createVNode("img", {
                src: _ctx.woodpackingAsset,
                alt: "icon-woodpacking"
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_24, [
              (_ctx.isStiDest)
                ? (_openBlock(), _createBlock("img", _hoisted_25))
                : (_openBlock(), _createBlock("img", _hoisted_26)),
              (_ctx.regionName)
                ? (_openBlock(), _createBlock("div", _hoisted_27, [
                    _createVNode("div", _hoisted_28, _toDisplayString(_ctx.regionName), 1),
                    _hoisted_29
                  ]))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.regionName)
              ? (_openBlock(), _createBlock("div", _hoisted_30, " Batas POD Hari Ini "))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.flag.toLowerCase() === 'lewat batas rts')
      ? (_openBlock(), _createBlock("div", _hoisted_31, [
          _createVNode("div", _hoisted_32, [
            _createVNode("div", _hoisted_33, [
              _createVNode("img", {
                src: _ctx.woodpackingAsset,
                alt: "icon-woodpacking"
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_34, [
              (_ctx.isStiDest)
                ? (_openBlock(), _createBlock("img", _hoisted_35))
                : (_openBlock(), _createBlock("img", _hoisted_36)),
              (_ctx.regionName)
                ? (_openBlock(), _createBlock("div", _hoisted_37, [
                    _createVNode("div", _hoisted_38, _toDisplayString(_ctx.regionName), 1),
                    _hoisted_39
                  ]))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.regionName)
              ? (_openBlock(), _createBlock("div", _hoisted_40, " Batas RTS Terlewati "))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.flag.toLowerCase() === 'rts sekarang')
      ? (_openBlock(), _createBlock("div", _hoisted_41, [
          _createVNode("div", _hoisted_42, [
            _createVNode("div", _hoisted_43, [
              _createVNode("img", {
                src: _ctx.woodpackingAsset,
                alt: "icon-woodpacking"
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_44, [
              (_ctx.isStiDest)
                ? (_openBlock(), _createBlock("img", _hoisted_45))
                : (_openBlock(), _createBlock("img", _hoisted_46)),
              (_ctx.regionName)
                ? (_openBlock(), _createBlock("div", _hoisted_47, [
                    _createVNode("div", _hoisted_48, _toDisplayString(_ctx.regionName), 1),
                    _hoisted_49
                  ]))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.regionName)
              ? (_openBlock(), _createBlock("div", _hoisted_50, " Batas RTS Hari ini "))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.flag.toLowerCase() === 'rts besok')
      ? (_openBlock(), _createBlock("div", _hoisted_51, [
          _createVNode("div", _hoisted_52, [
            _createVNode("div", _hoisted_53, [
              _createVNode("img", {
                src: _ctx.woodpackingAsset,
                alt: "icon-woodpacking"
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_54, [
              (_ctx.isStiDest)
                ? (_openBlock(), _createBlock("img", _hoisted_55))
                : (_openBlock(), _createBlock("img", _hoisted_56)),
              (_ctx.regionName)
                ? (_openBlock(), _createBlock("div", _hoisted_57, [
                    _createVNode("div", _hoisted_58, _toDisplayString(_ctx.regionName), 1),
                    _hoisted_59
                  ]))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.regionName)
              ? (_openBlock(), _createBlock("div", _hoisted_60, " Batas RTS Besok "))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.flag.toLowerCase() === 'hal sekarang')
      ? (_openBlock(), _createBlock("div", _hoisted_61, [
          _createVNode("div", _hoisted_62, [
            _createVNode("div", _hoisted_63, [
              _createVNode("img", {
                src: _ctx.woodpackingAsset,
                alt: "icon-woodpacking"
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_64, [
              (_ctx.isStiDest)
                ? (_openBlock(), _createBlock("img", _hoisted_65))
                : (_openBlock(), _createBlock("img", _hoisted_66)),
              (_ctx.regionName)
                ? (_openBlock(), _createBlock("div", _hoisted_67, _toDisplayString(_ctx.regionName), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.flag.toLowerCase() === 'kayu' || !_ctx.flag)
      ? (_openBlock(), _createBlock("div", _hoisted_68, [
          _createVNode("div", _hoisted_69, [
            _createVNode("div", _hoisted_70, [
              _createVNode("img", {
                src: _ctx.woodpackingAsset,
                alt: "icon-woodpacking"
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_71, [
              (_ctx.isStiDest)
                ? (_openBlock(), _createBlock("img", _hoisted_72))
                : (_openBlock(), _createBlock("img", _hoisted_73)),
              (_ctx.regionName)
                ? (_openBlock(), _createBlock("div", _hoisted_74, [
                    _createVNode("div", _hoisted_75, _toDisplayString(_ctx.regionName), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}